import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ReactiveComponent } from '@schenck/rotec-components';
import { getToolingTaskModalInfos, TaskModalService } from 'src/components';
import { ToolingTaskModalService } from './tooling-task-modal.service';
import { TaskModalComponent } from '../../../components/task-modal/task-modal/task-modal.component';

@Component({
  selector: 'ma-tooling-task-modal',
  templateUrl: './tooling-task-modal.component.html',
  providers: [
    ToolingTaskModalService,
    { provide: TaskModalService, useExisting: ToolingTaskModalService },
  ],
  imports: [TaskModalComponent],
})
export class ToolingTaskModalComponent extends ReactiveComponent {
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly taskModalService = inject(ToolingTaskModalService);
  private readonly translate = inject(TranslateService);

  public state = this.connect(
    getToolingTaskModalInfos(
      this.taskModalService.task$,
      this.taskModalService.tooling$,
      this.taskModalService.plants$,
      this.taskModalService.machines$,
      this.translate
    ),
    this.cdr
  );

  constructor() {
    super();
  }
}
